document.addEventListener('alpine:init', () => {
  var { formatMoney, randomUUID } = Alpine.store('utilities');

  function productForm(data = {}) {
    return {
      ...data,

      isLoading: false,

      key: randomUUID(),

      get formData() {
        var formData = new FormData(this.$el);
  
        formData.set('sections', ['mini-cart']);
  
        return formData;
      },

      get selectedVariant() {
        return this.product?.variants.find((variant) => variant.id == this.selectedVariantId);
      },

      get selectedVariantPrice() {
        var price = this.selectedVariant.price;

        if (this.selectedQuantityBreak) {
          price = price - (this.selectedQuantityBreak.value);
        }

        return price;
      },

      get selectedVariantPriceFormatted() {
        return formatMoney(this.selectedVariantPrice);
      },

      get selectedVariantColorShade() {
        return this.variantColorShadeAll && this.variantColorShadeAll[this.selectedVariantId];
      },

      get selectedQuantityBreak() {
        return this.quantityBreakAll.findLast((quantityBreak) => {
          return this.selectedQuantity >= quantityBreak.key;
        });
      },

      get selectedPrice() {
        var price = this.selectedVariantPrice * this.selectedQuantity;

        if (this.selectedIsLogo) {
          price += window.global.settings.productLogo.price;
        }

        if (this.selectedIsRushPrinting) {
          price += window.global.settings.productRushPrinting.price;
        }

        return price;
      },

      get selectedPriceFormatted() {
        return formatMoney(this.selectedPrice);
      },

      get selectedIsLogo() {
        return this.selectedProperties['Printing Option'].includes('Logo');
      },

      get selectedIsRushPrinting() {
        return this.selectedProperties['Rush Printing'].includes('Yes');
      },

      init() {
        this.$el.addEventListener('submit', (event) => {
          event.preventDefault();
          this.onSubmit();
        });

        this.$watch('selectedVariantId', () => {
          this.$dispatch('produtformselectedvariantchange', { selectedVariantId: this.selectedVariantId });
          this.updateUrl();
        });

        this.$watch('selectedVariantColorShade', () => {
          var customOption = this.getCustomOption('Print Color');

          var listItem = customOption.list.find((listItem) => {
            return listItem.colorShade == this.selectedVariantColorShade;
          });

          if (listItem) {
            this.selectedProperties['Print Color'] = listItem.value;
          }
        });

        this.removeSelectedValueCartAttributes();
      },

      onSubmit() {
        if (this.isLoading) return;

        this.isLoading = true;

        var fetchUrl = `${this.$el.action}.js`;
  
        var fetchOptions = {
          method: this.$el.method,
          body: this.formData
        };

        this.getPreSubmitPromise()
          .then(() => fetch(fetchUrl, fetchOptions))
          .then((res) => {
            if (!res.ok) {
              throw new Error();
            }

            return res.json();
          })
          .then((res) => {
            this.$dispatch('productformsubmitsuccess', { res });
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.isLoading = false;
            this.updateKey = null;
            this.key = randomUUID();
          });
      },

      getPreSubmitPromise() {
        if (!this.updateKey) {
          return Promise.resolve();
        }

        var updates = window.global.cart.items.map((item) => {
          if (item.properties._key == this.updateKey) return 0;

          return item.quantity;
        });

        var fetchUrl = `${window.global.routes.cart_update_url}.js`;

        var fetchOptions = {
          method: 'post',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        };

        return fetch(fetchUrl, fetchOptions);
      },

      updateUrl() {
        var url = new URL(location);
  
        url.searchParams.set('variant', this.selectedVariantId);
  
        history.replaceState(null, null, url);
      },

      getCustomOption(propertyName) {
        return this.customOptionAll.find((customOption_) => {
          return customOption_.propertyName == propertyName;
        });
      },

      getCustomOptionSelectedListItem(propertyName) {
        var customOption = this.getCustomOption(propertyName);

        var customOptionSelectedListItem = customOption.list.find((listItem) => {
          return listItem.value == this.selectedProperties[propertyName];
        });

        return customOptionSelectedListItem;
      },

      getCustomOptionEnabledState(propertyName) {
        var customOption = this.getCustomOption(propertyName);
      
        var isEnabled = true;

        var isConditionalRuleEnabled = (
          customOption.conditionalRulePropertyName &&
          customOption.conditionalRulePropertyValues
        );

        if (isConditionalRuleEnabled) {
          isEnabled = customOption.conditionalRulePropertyValues.includes(this.selectedProperties[customOption.conditionalRulePropertyName]);
        }

        return isEnabled;
      },

      removeSelectedValueCartAttributes() {
        var selectedValueAttributeNames = Object.keys(window.global.cart.attributes).filter((key) => {
          return key.includes('product_selected_');
        });

        if (!selectedValueAttributeNames.length) return;

        var attributes = selectedValueAttributeNames.reduce((acc, attributeName) => {
          acc[attributeName] = null;

          return acc;
        }, {});

        var fetchUrl = `${window.global.routes.cart_update_url}.js`;

        var fetchOptions = {
          method: 'post',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ attributes })
        };

        fetch(fetchUrl, fetchOptions);
      },
    };
  };

  Alpine.data('productForm', productForm);
});
